var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2ToiletsRoomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 12.93v21.14A3.93 3.93 0 0157.07 38H48V12.93A3.93 3.93 0 0151.93 9h5.14A3.93 3.93 0 0161 12.93zM18.38 42c0 6 6.93 10 14.64 10h6v16H53V42H18.38zM44 34H15.88a2 2 0 000 4H44v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Toilets_room_bis.04a5f15c.svg";
export { SvgE2ToiletsRoomBis as ReactComponent };